import { CSSResultGroup } from 'lit';
import { customElement, query } from 'lit/decorators.js';
import componentStyles from './ghs-admin-links.css.lit';
import { OutlineAdminLinks } from '../../base/outline-admin-links/outline-admin-links';

/**
 * The Outline Admin Links component
 * @element ghs-admin-links
 * @slot - The default, and only slot for this element.
 */
@customElement('ghs-admin-links')
export class GhsAdminLinks extends OutlineAdminLinks {
  static styles: CSSResultGroup = [componentStyles];

  @query('.tabs__trigger')
  private trigger: HTMLButtonElement;

  @query('.links')
  private wrapper: HTMLElement;

  _handleTriggerClick() {
    this.trigger.addEventListener('click', () => {
      this.wrapper.classList.toggle('is-open');
    });
  }

  firstUpdated(): void {
    super.firstUpdated();
    setTimeout(() => this._handleTriggerClick());
  }
}
